import React from "react";
import contextProvider from "../../../contextProvider";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";

import _ReactOBaseComponent from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";

import Panel from "../../../_L1_components/Layout/Panel";
import ReactOActionBar from "../../../_L1_components/Elements/ReactOActionBar";
import ReactOForm from "../../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../../_L1_components/Elements/ReactOFormInput";

class ProbeSetupSignalTHold extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      isReserved: false,
      reservationStarted: false,
    };
    super(props, initState);
  }

  loadProbeSetup(cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        if (this.props.onConfLoad && !this.loop) {
          this.props.onConfLoad();
        }
        this.apiStore.fire("meet_reservation_status", {
          data: {
            probeuid: this.props.match.params.probeuid,
          },
          ___onSuccess: (status, data) => {
            if (
              !this.state.reservationStarted &&
              data.callStarted == 1 &&
              data.callEndsIn > 0
            ) {
              this.setState({ reservationStarted: true });
            }

            if (data.reservation == 0 || data.reservation == 1) {
              this.setState({ reservationStarted: false });
            }

            if (this.mounted) {
              this.setState(
                {
                  data: data,
                  loading: false,
                },
                () => {
                  this.loop = setTimeout(() => {
                    this.loadProbeSetup();
                  }, 20000);
                }
              );
            }
          },
          ___onError: (error, data) => {
            this.setState(
              {
                loading: false,
              },
              () => {
                this.loop = setTimeout(() => {
                  this.loadProbeSetup();
                }, 10000);
              }
            );
          },
        });
      }
    );
  }

  saveProbeSetup(data, cb) {
    // console.log("DEBUG :: ProbeSetup _ saveProbeSetup", data);
    const { minutes } = data;
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("meet_reservation_set", {
          data: {
            probeuid: this.props.match.params.probeuid,
            minutes,
          },
          ___onSuccess: (status, data) => {
            this.setState(
              {
                loading: false,
              },
              () => {
                this.loadProbeSetup();
                if (cb) {
                  cb(status, data);
                }
              }
            );
          },
        });
      }
    );
  }

  parseTime(time, isTimeout) {
    const minutes = ~~((time % 3600) / 60);
    const seconds = ~~time % 60;

    if (minutes == 0) {
      if (seconds < 20) return "less than 30 seconds";
      if (seconds >= 20 && seconds < 40)
        return `${isTimeout ? "" : "in"} about 30 seconds`;
      if (seconds >= 40 && seconds < 60)
        return `${isTimeout ? "" : "in"} about ${minutes + 1} ${
          minutes + 1 > 1 ? "minutes" : "minute"
        }`;
    }

    if (minutes > 0) {
      if (seconds < 20)
        return `${isTimeout ? "" : "in"} about ${minutes} ${
          minutes > 1 ? "minutes" : "minute"
        }`;
      if (seconds >= 20 && seconds < 40)
        return `${isTimeout ? "" : "in"} about  ${minutes} ${
          minutes > 1 ? "minutes" : "minute"
        } and 30 seconds`;
      if (seconds >= 40 && seconds < 60)
        return `${isTimeout ? "" : "in"} about ${minutes + 1} ${
          minutes + 1 > 1 ? "minutes" : "minute"
        }`;
    }
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    this._probe_setup_form.init();
    this.loadProbeSetup();
  }

  onComponentWillUnmount() {
    this.mounted = false;
    if (this.loop) {
      clearTimeout(this.loop);
    }
  }

  onRender() {
    return (
      <_LoadingWrapper loadingPlug={this.state.loading}>
        <Panel
          className="mb-4 rounded-bottom"
          //	header="GENERAL SETTINGS"
          style={{
            minHeight: "100px",
          }}
        >
          <ReactOForm
            onSubmit={this.saveProbeSetup.bind(this)}
            unsavedWarning={true}
            onControllerReady={(form_controller) => {
              this._probe_setup_form = form_controller;
            }}
            // preSubmit={(form_data) => {
            //   if (!this.state.isReserved) {
            //     let reservation = {
            //       name: form_data.reservation.split(" ")[0],
            //       surname: form_data.reservation.split(" ")[1],
            //     };
            //     form_data.reservation = reservation;
            //   }
            //   return form_data;
            // }}
          >
            {this.state.data && (
              <>
                <Row className="mb-3">
                  {this.state.data.reservation == 0 && (
                    <>
                      <Col xs={12} sm={6} lg={6}>
                        <div className="mb-2 text-gray600">
                          <strong>Reserve a meet with duration:</strong>
                        </div>
                        <ReactOFormInput
                          className="mb-3 select-conf"
                          type="select"
                          data_key="minutes"
                          noSelectionLabel="---"
                          options={() => {
                            return [
                              { name: "3 minutes", value: "3" },
                              { name: "5 minutes", value: "5" },
                              { name: "7 minutes", value: "7" },
                              { name: "10 minutes", value: "10" },
                            ];
                          }}
                          validators={[
                            {
                              func: (value) => {
                                return value != undefined;
                              },
                              invalid_text: "Choose a duration",
                            },
                          ]}
                        />
                      </Col>
                    </>
                  )}
                  {this.state.data.reservation == 1 ||
                  (this.state.data.reservation == 2 &&
                    this.state.data.callStarted == 0) ? (
                    <>
                      <Col xs={12} sm={6} lg={6}>
                        {this.state.data.nextCallIn < 15 ? (
                          <div>Meet with your reservation will start shortly</div>
                        ) : (
                          <div>
                            Meet with your reservation will start{" "}
                            {this.parseTime(this.state.data.nextCallIn)}
                          </div>
                        )}
                      </Col>
                    </>
                  ) : null}
                  {this.state.data.reservation == 2 &&
                    this.state.data.callStarted == 1 && (
                      <>
                        <Col xs={12} sm={6} lg={6}>
                          <div className="mb-2">
                            <p>Meet with your reservation:</p>
                          </div>
                          <div className="mb-2">
                            <div>
                              MeetID <strong>{this.state.data.meetid}</strong>
                            </div>
                            <div>
                              Passcode <strong>{this.state.data.passcode}</strong>
                            </div>
                          </div>
                          {this.state.data.callEndsIn < 0 &&
                            !this.state.reservationStarted && (
                              <div>
                                Meet duration:{" "}
                                {this.state.data.reservation_timeout || "-"} minutes
                              </div>
                            )}
                          {this.state.data.callEndsIn < 0 &&
                            this.state.reservationStarted && <div>Meet ends shortly</div>}
                          {this.state.data.callEndsIn > 0 && (
                            <div className="mt-2">
                              Meet duration:{" "}
                              {this.parseTime(this.state.data.callEndsIn, true)}
                            </div>
                          )}
                        </Col>
                      </>
                    )}
                </Row>
                {this.state.data.reservation == 0 && (
                  <ReactOActionBar align="right" padding="0">
                    <ReactOFormInput
                      type="submit"
                      value="Save"
                      color="primary"
                      // icon="save"
                    >
                      Reserve
                    </ReactOFormInput>
                  </ReactOActionBar>
                )}
              </>
            )}
          </ReactOForm>
        </Panel>
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(
  withRouter(ProbeSetupSignalTHold),
  //	withDefinedContext(ProbeSetupSignalTHold, 'ProbeSetupSignalTHold', context_exposed_methods),
  {
    define: null,
  }
);
